import { Loader } from 'pixi.js'
import { assets, initAssets, particle, splashAssets } from 'settings/custom/assets'
import { parseAssets } from 'utils/AssetParser'

export const LoadManager = { init, main, splash, particleAssets }

function init() {
  return new Promise((res) => {
    // eslint-disable-next-line no-unused-vars
    Loader.shared.add(initAssets).load((Loader, resources) => {

      game.assets.initAssets = parseAssets(resources)
      pushTexture(game.assets.initAssets.atlas)
      res()
    })
  })
}

function splash() {
  return new Promise((res) => {
    // eslint-disable-next-line no-unused-vars

    Loader.shared.add(splashAssets).load((Loader, resources) => {

      game.assets.splashAssets = parseAssets(resources)
      pushTexture(game.assets.splashAssets.atlas)

      res()
    })
  })
}

function pushTexture(tex){
  game.assets.textures.push(tex)
}

function particleAssets() {
  return new Promise((res) => {
    // eslint-disable-next-line no-unused-vars
    if(particle !== undefined){
      Loader.shared.add(particle).load((Loader, resources) => {

        game.assets.particle = parseAssets(resources)
        pushTexture(game.assets.particle.atlas)
        res()
      })
    }
    else{
      res()
    }

  })
}

function main() {
  return new Promise((res) => {
    // eslint-disable-next-line no-unused-vars
    Loader.shared.add(assets).load((Loader, resources) => {
      game.assets.main = parseAssets(resources)
      pushTexture(game.assets.main.atlas)
      res()
    })

  })
}
